import React from 'react';
import NoImagePlaceHolder from '@/assets/no_image_placeholder.svg';
import clsx from 'clsx';

type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  imageSource?: string;
};

const Image = React.forwardRef<HTMLImageElement, Props>(
  ({ className, imageSource, ...rest }, ref) => {
    return (
      <img
        ref={ref}
        src={imageSource ?? NoImagePlaceHolder}
        className={clsx('w-10 h-10 rounded object-cover', className)}
        {...rest}
      />
    );
  },
);

export default Image;
